import { useCallback, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import GalleryItem from "../../Gallery/GalleryItem";
import ModalMedia from "../ModalMedia";
import { useTranslationApp } from "../../../lib/i18next";
import { MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE } from "../../../i18n/keysTranslations";
import { INPUT_COLOR_BORDER, BOX_SHADOW_THEME } from "../../../utils/colors";
import { BORDER_RADIUS } from "../../../utils/constants";
import { getPurchaseVideoExamples } from "../../../utils/purchaseVideoExamples";

const onNoop = () => {};

const VideoPurchaseExamples = () => {
  const { t, i18n } = useTranslationApp();
  const [unmutedVideoKey, setUnmutedVideoKey] = useState(null);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);
  const videoExamples = getPurchaseVideoExamples({
    language: i18n.language,
  });

  const onRequestVideoUnmute = useCallback(({ videoMuteKey }) => {
    setUnmutedVideoKey(videoMuteKey);
  }, []);

  const onRequestVideoMute = useCallback(() => {
    setUnmutedVideoKey(null);
  }, []);

  if (videoExamples.length === 0) {
    return null;
  }
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        px: 2,
        py: 1.5,
        mt: 1,
        borderRadius: BORDER_RADIUS,
        border: `1px solid ${INPUT_COLOR_BORDER}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: BOX_SHADOW_THEME,
      })}
    >
      <Typography
        sx={{
          fontSize: "0.875rem",
          fontWeight: 600,
          color: "text.primary",
        }}
      >
        {t(MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE)}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(${Math.min(videoExamples.length, 3)}, 1fr)`,
          gap: 1,
        }}
      >
        {videoExamples.map((url, index) => (
          <GalleryItem
            key={url}
            item={{ id: url, url, width: 9, height: 16 }}
            index={index}
            multiple={false}
            isSelected={false}
            showActionButtons={false}
            showDeleteButton={false}
            showDownloadButton={false}
            showDimensionsOverlay={false}
            showResizeFormatButton={false}
            showEditButton={false}
            showPostButton={false}
            showReportButton={false}
            showFeedbackButtons={false}
            showExpandButton={false}
            unmutedVideoKey={unmutedVideoKey}
            onRequestVideoUnmute={onRequestVideoUnmute}
            onRequestVideoMute={onRequestVideoMute}
            onSelectItem={onNoop}
            onSelectPreview={() => {
              setUnmutedVideoKey(null);
              setSelectedVideoUrl(url);
            }}
            onDeleteItem={onNoop}
            onDownloadItems={onNoop}
            onFailedLoadUrl={onNoop}
          />
        ))}
      </Box>
      {selectedVideoUrl ? (
        <ModalMedia
          modalOpen
          url={selectedVideoUrl}
          onCloseModal={() => setSelectedVideoUrl(null)}
          showEditButton={false}
          showDownloadButton={false}
          showShareButton={false}
          showDeleteButton={false}
        />
      ) : null}
    </Box>
  );
};

export default VideoPurchaseExamples;
